/* eslint-disable no-console */
import { convertirAMonedaLocal, loadExchangeRates } from "./exchangeRateService";
import { client } from "./supabase";

/**
 * Obtiene la inversión mensual en activos (CAPEX) para un año dado.
 * @param {string} pais - "Chile" o "Perú"
 * @param {number} year - Año para calcular (ej: 2025)
 * @returns {Promise<number[]>} Array de 12 elementos con inversión de cada mes EN MONEDA LOCAL
 */
export const getInversionMensual = async (pais, year) => {
  const yearNum = Number(year);
  try {
    await loadExchangeRates();

    const { data: activos, error } = await client
      .from("activos")
      .select("fecha_compra, costo_unitario, cantidad, moneda, estado")
      .eq("pais", pais)
      .eq("eliminado", false);

    if (error) throw error;
    if (!activos?.length) return Array(12).fill(0);

    const inversionPorMes = Array(12).fill(0);

    for (const activo of activos) {
      // Planificados y activos sin fecha_compra NO son inversión devengada — mismo criterio que
      // getValorActivosMensual / resumenInversionEdificio. Una planificada aún no se compró. Ver 3.1.5 / 7.4.
      if (!activo.fecha_compra || activo.estado === "planificado") continue;
      const [yearCompra, monthCompra] = activo.fecha_compra.split("-").map(Number);
      if (yearCompra !== yearNum) continue;

      const costoTotal = parseFloat(activo.costo_unitario) * activo.cantidad;
      const fechaStr = `${yearNum}-${String(monthCompra).padStart(2, "0")}-15`;
      const enMonedaLocal = convertirAMonedaLocal(costoTotal, activo.moneda, pais, fechaStr);

      inversionPorMes[monthCompra - 1] += Math.round(enMonedaLocal);
    }

    return inversionPorMes;
  } catch (error) {
    console.error("Error en getInversionMensual:", error);
    return Array(12).fill(0);
  }
};
